/* eslint-disable react/jsx-boolean-value */
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CardAction from '../../../../components/card/CardAction';
import { useAddRemoveFromGroupPlay } from './AddRemoveFromGroupPlayHooks';
import './AddToGroupPlay.scss';
import { useDomain } from '../../../../states/AppDomainProvider';
import ChurnZeroService from '../../../../services/ChurnZeroService';
import { CHURNZERO_CONSTANT } from '../../../../constants/ChurnZeroConstant';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

/**
 * Share Link Lesson Action Container
 */
const defaultProps = {
  onSaveSuccess: () => { },
};

export default function AddToGroupPlay(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { lesson, onSaveSuccess } = mergedProps;
  const { userDomain } = useDomain();
  const { user } = userDomain.domainData;
  const { addLessonToGroupPlay } = useAddRemoveFromGroupPlay(lesson, onSaveSuccess);
  const handleOnAddToGroupPlay = () => {
    addLessonToGroupPlay();
    ChurnZeroService.trackEvent(CHURNZERO_CONSTANT.USAGE, 'Prep for group inst.', user);
  };

  return (
    <CardAction
      icon={<AddCircleIcon aria-hidden='false' />}
      label='GROUP INSTRUCTION'
      ariaLabel='Add to Group Instruction'
      title='Add to Group Instruction'
      className='add-to-group-play-action'
      actionHandler={handleOnAddToGroupPlay}
      data-test='add-to-group-play-action'
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
